import React, {memo} from "react";

export const IconSkullFull = memo(({color}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{"mix-blend-mode": "color-burn"}}>
        <path
          d="M13 13C11.622 13 10.5 11.878 10.5 10.5C10.5 9.122 11.622 8 13 8C14.378 8 15.5 9.122 15.5 10.5C15.5 11.878 14.378 13 13 13Z"
          fill={color || "#000"}
        />
      </g>
      <path
        d="M14.5 20C14.224 20 14 19.776 14 19.5V16.5C14 15.176 14.809 13.87 15.842 13.526C16.459 13.32 17 12.374 17 11.5V9.5C17 5.364 13.636 2 9.5 2C5.364 2 2 5.364 2 9.5V11.5C2 12.373 2.541 13.32 3.158 13.526C4.191 13.87 5 15.177 5 16.5V19.5C5 19.776 4.776 20 4.5 20C4.224 20 4 19.776 4 19.5V16.5C4 15.627 3.459 14.68 2.842 14.474C1.809 14.13 1 12.823 1 11.5V9.5C1 7.23 1.884 5.095 3.49 3.49C5.096 1.885 7.23 1 9.5 1C11.77 1 13.905 1.884 15.51 3.49C17.115 5.096 18 7.23 18 9.5V11.5C18 12.824 17.191 14.13 16.158 14.474C15.541 14.68 15 15.626 15 16.5V19.5C15 19.776 14.776 20 14.5 20V20Z"
        fill={color || "#000"}
      />
      <path
        d="M6.5 20C6.224 20 6 19.776 6 19.5V17.5C6 17.224 6.224 17 6.5 17C6.776 17 7 17.224 7 17.5V19.5C7 19.776 6.776 20 6.5 20Z"
        fill={color || "#000"}
      />
      <path
        d="M8.5 20C8.224 20 8 19.776 8 19.5V17.5C8 17.224 8.224 17 8.5 17C8.776 17 9 17.224 9 17.5V19.5C9 19.776 8.776 20 8.5 20Z"
        fill={color || "#000"}
      />
      <path
        d="M10.5 20C10.224 20 10 19.776 10 19.5V17.5C10 17.224 10.224 17 10.5 17C10.776 17 11 17.224 11 17.5V19.5C11 19.776 10.776 20 10.5 20Z"
        fill={color || "#000"}
      />
      <path
        d="M12.5 20C12.224 20 12 19.776 12 19.5V17.5C12 17.224 12.224 17 12.5 17C12.776 17 13 17.224 13 17.5V19.5C13 19.776 12.776 20 12.5 20Z"
        fill={color || "#000"}
      />
      <path
        d="M10.438 15.786C10.33 15.786 10.214 15.765 10.092 15.725C9.944 15.676 9.729 15.648 9.5 15.648C9.271 15.648 9.056 15.676 8.908 15.725C8.786 15.766 8.67 15.786 8.562 15.786C8.294 15.786 8.07 15.662 7.948 15.445C7.838 15.25 7.772 14.909 8.086 14.386L8.557 13.601C8.784 13.222 9.128 13.005 9.5 13.005C9.872 13.005 10.216 13.222 10.443 13.601L10.914 14.386C11.228 14.909 11.162 15.251 11.052 15.445C10.929 15.662 10.705 15.786 10.438 15.786V15.786ZM9.5 14.647C9.644 14.647 9.785 14.655 9.92 14.671L9.586 14.114C9.549 14.052 9.517 14.023 9.5 14.01C9.483 14.023 9.451 14.052 9.414 14.114L9.08 14.671C9.214 14.655 9.356 14.647 9.5 14.647Z"
        fill={color || "#000"}
      />
      <g style={{"mix-blend-mode": "color-burn"}}>
        <path
          d="M6.5 13C5.122 13 4 11.878 4 10.5C4 9.122 5.122 8 6.5 8C7.878 8 9 9.122 9 10.5C9 11.878 7.878 13 6.5 13Z"
          fill="black"
        />
      </g>
    </svg>
  );
});
